module.exports = __webpack_public_path__ + "img/th-flag.b1ef70d5.svg";